export default __webpack_public_path__ + "static/Kira Kutcher - Age 18 High School Graduation-f3a8d16d41977ba0290549c9b4037de8.png";